import { Component, inject, ViewChild, OnInit, PLATFORM_ID, Inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NewsletterService } from '../../_services/newsletter/newsletter.service';
import { ToastComponent } from '../../_components/toast/toast.component';
import { FormsModule } from '@angular/forms';
import { ActualiteService } from '../../_services/actualite/actualite.service';
import { EvenementService } from '../../_services/evenement/evenement.service';
import { Actualite } from '../../_interfaces/actualite';
import { Evenement } from '../../_interfaces/evenement';
import { ActualiteCardComponent } from '../../_components/actualite-card/actualite-card.component';
import { SeoService } from '../../_services/seo/seo.service';
import { ConsentEmbedComponent } from '../../_components/consent-embed/consent-embed.component';
import { ASSOCIATION } from '../../_config/association';

@Component({
    selector: 'app-home',
    imports: [CommonModule, ToastComponent, FormsModule, RouterModule, ActualiteCardComponent, ConsentEmbedComponent],
    templateUrl: './home.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  @ViewChild(ToastComponent) toast!: ToastComponent;


  private seo = inject(SeoService);
  association = ASSOCIATION;
  evenementService = inject(EvenementService);
  newsletterService = inject(NewsletterService);
  carouselElement!: HTMLElement;
  email = '';
  newsletterConsent = false;
  newsletterSending = false;
  mapsEmbedUrl = 'https://maps.google.com/maps?hl=fr&q=124%20rue%20de%20bagnolet+(La%20Bourr%C3%A9e%20de%20Paris)&t=&z=13&ie=UTF8&iwloc=B&output=embed';
  actualiteService = inject(ActualiteService);
  
  evenements: Evenement[] = [];
  actualites: Actualite[] = [];
  
  private readonly PREVIEW_LENGTH = 150;

  ngOnInit() {
    this.updateMeta();
    this.retrieve_evenements();
    this.retrieve_actualites();
  }

  stripHtml(html: string): string {
    if (isPlatformBrowser(this.platformId)) {
      const tmp = document.createElement('DIV');
      tmp.innerHTML = html;
      const text = tmp.textContent || tmp.innerText || '';
      
      if (text.length <= this.PREVIEW_LENGTH) {
        return text;
      }
      
      return text.slice(0, this.PREVIEW_LENGTH) + '...';
    }
    // Fallback pour le rendu côté serveur
    const text = html.replace(/<[^>]*>/g, '');
    if (text.length <= this.PREVIEW_LENGTH) {
      return text;
    }
    return text.slice(0, this.PREVIEW_LENGTH) + '...';
  }

  updateMeta(){
    this.seo.set({
      title: ASSOCIATION.nom,
      description: "La Bourrée de Paris : groupe folklorique auvergnat à Paris, offrant danse, musique et chants traditionnels depuis 1925 pour tous types d'événements.",
      path: '/',
    });
  }

  retrieve_evenements(){
    // Récupérer les événements
    this.evenementService.readXEvenements(3).subscribe(evenements => {
      this.evenements = evenements;
    });
  }

  async onNewsletterSubmit() {
    const email = this.email.trim();
    if (!email) {
      this.showToast('Renseignez votre adresse email.', 'error');
      return;
    }
    if (!this.newsletterConsent) {
      this.showToast('Cochez la case pour accepter de recevoir la newsletter.', 'error');
      return;
    }
    this.newsletterSending = true;
    try {
      await this.newsletterService.createNewsletter(email);
      this.showToast('Merci, votre inscription à la newsletter est enregistrée.', 'success');
      this.email = '';
      this.newsletterConsent = false;
    } catch {
      this.showToast("L'inscription n'a pas pu être enregistrée. Réessayez plus tard ou écrivez-nous.", 'error');
    } finally {
      this.newsletterSending = false;
    }
  }

  showToast(str: string, type: 'success' | 'error' | 'info' = 'info') {
    this.toast.showToast(str, type);
  }

  retrieve_actualites() {
    this.actualiteService.readPublishedActualites().subscribe(
      actualites => {
        this.actualites = actualites.slice(0, 3);
      },
      error => console.error('Erreur lors de la récupération des actualités:', error)
    );
  }
}
